import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from './defaultIconStyles.css';

type Props = IconProps & React.SVGProps<SVGSVGElement>;
export const IconPlus = ({
    width = '16',
    height = '16',
    className,
    ...rest
}: Props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        className={classnames(css.main, className)}
        {...rest}
    >
        <path
            d=" M 14.189 7.121 L 8.97 7.121 L 8.97 1.915 C 8.97 1.422 8.547 1 8.053 1 C 7.559 1 7.136 1.422 7.136 1.915 L 7.136 7.05 L 1.917 7.05 C 1.423 7.121 1 7.543 1 8.035 C 1 8.528 1.423 8.95 1.917 8.95 L 7.065 8.95 L 7.065 14.085 C 7.065 14.578 7.489 15 7.982 15 C 8.476 15 8.899 14.578 8.899 14.085 L 8.899 8.95 L 14.048 8.95 C 14.4 8.95 14.683 8.739 14.894 8.457 C 15.035 8.176 15.035 7.824 14.894 7.543 C 14.824 7.261 14.471 7.121 14.189 7.121 Z "
            fillRule="evenodd"
            className={css.colored}
        />
    </svg>
);

export default IconPlus;
